import { render } from "./TeamMemberSummary.vue?vue&type=template&id=05b081d4"
import script from "./TeamMemberSummary.vue?vue&type=script&lang=js"
export * from "./TeamMemberSummary.vue?vue&type=script&lang=js"
script.render = render

export default script